import { useEffect, useState } from "react";
import "./CardTut.css";
import { Col, Row } from "antd";

interface CardTutProps {
  srcurl: string;
  titolo: string;
  descrizione: string;
  width: number;
}

const CardTut: React.FC<CardTutProps> = ({
  srcurl,
  titolo,
  descrizione,
  width,
}) => {
  return (
    <>
      {width > 640 && (
        //Desktop
        <>
          <Col span={12}>
            <Row className="spaceup">
              <div className="carde">
                <button className="buttone Explore">
                  <iframe
                    className="videox"
                    width="210"
                    height="157"
                    src={srcurl}
                  ></iframe>
                </button>

                <button className="buttone">
                  <h1 className="upper">{titolo}</h1>

                  <h5 className="dupper">{descrizione}</h5>
                </button>
              </div>
            </Row>
          </Col>
        </>
      )}
      {width < 640 && (
        <>
          <div className="cardes">
            <button className="buttone Explore">
              <iframe
                className="videoxs"
                width="250"
                height="140"
                src={srcurl}
              ></iframe>

              <h3 className="uppers">{titolo}</h3>

              <h5 className="duppers">{descrizione}</h5>
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default CardTut;
